import Estacoes from "views/Public/Estacoes";
import Home from "views/Public/Home";
import StationDetails from "views/Public/StationDetails";
import IntegrationDocs from "views/Public/IntegrationDocs";

var publicRoutes = [
    {
        path: "/estacao/:id",
        name: "Station",
        component: StationDetails,
    },
    {
        path: "/integrations/documentation",
        name: "API de Integração",
        component: IntegrationDocs,
    },
    {
        path: "/",
        name: "Mapa",
        component: Home,
    },
    {
        path: "/estacoes",
        name: "Estacoes",
        component: Estacoes,
    },
];
export default publicRoutes;
